import VirtualTable from './src/index'

VirtualTable.install = Vue => {
  Vue.component(VirtualTable.name, VirtualTable)
}

export default VirtualTable
